import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { ApiService } from '../../core/services/api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Apiconfig } from '../../core/helpers/apiConfig';
import { NotificationService } from '../../core/services/notification.service';
import { filter } from 'rxjs';
import { FormsModule, NgForm } from '@angular/forms';


@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule,RouterLink,FormsModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  todayDate = new Date().toISOString().split('T')[0];

  constructor(
    private route: Router,
    private apiService: ApiService,
    
   
    private notifyService: NotificationService,
    private sanitizer: DomSanitizer,
    private routes: ActivatedRoute
  ) {}


  ngOnInit(): void {
    this.route.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // this.urlData = event.url
        // this.footerData = event.url;
      });


    // this.apiService.CommonApi(Apiconfig.getSocialLink.method, Apiconfig.getSocialLink.url, {}).subscribe(result => {
    //   if (result && result.link) {
    //     this.socialLink = result.link ? result.link.filter(e => { return e.status == '1' }) : [];
    //   }
    // })

    // this.featured_categories()

    // this.apiService.CommonApi(Apiconfig.pagesData.method, Apiconfig.pagesData.url, {}).subscribe(result => {
    //   // console.log(result, 'result the dataa');

    //   if (result && result.status) {
    //     this.pageList = result.data;


    //   }
    // })


    // this.get_widgts()
  }
 onSubmit(form: NgForm) {
    // if (!this.acceptTerms) {
    //   this.notifyService.showError("Please accept the Terms & Conditions to submit the form.");
    //   return;
    // }

    if (form.valid) {
      console.log('Form Data:', form.value);
      // contactForm
      this.apiService.commonApi(Apiconfig.contactForm.method, Apiconfig.contactForm.url, form.value).subscribe((result:any) => {        
        if (result && result.status == 1) {
          // Success logic here
          form.resetForm();
          // this.acceptTerms = false; // Reset checkbox manually
          this.notifyService.success("Submitted Successfully");
        } else {
          this.notifyService.error(result.message);
        }
      })

    } else {
      console.log('Form Invalid');
    }
  }
  contactus() {
    this.route.navigate(['/contact-us']);
  }
}
